<template>
	<div>
		<TableView
			:pagination="pagination"
			:response="response"
			:onEditAll="onEditAll"
			:onSearch="getRiscoLaboratorio"
			:tableHead="tableHead"
			:tableData="tableData"
			:loadingTable="config.loading.table"
			:config="config"
			disabledConfigCell
		/>
	</div>
</template>

<script>

	import TableView from 'common/table'
	import Rest from 'common/rest'
	import EdModal from 'common/modal'
	import EdForm from 'common/form'
	import FormItems from 'appsWeb/parceiro/_form/parceiro-exame-cadastrar'

	export default {
		name:"parceiro.exame",
		components: {TableView,EdModal,EdForm},
		mixins:[Rest],
		props:{
			laboratorio:{
				type:Object,
				default:null
			}
		},
		watch:{
			laboratorio(){
			},
			'formData.id_lab'(){
				this.config.disabled.id_exa = (this.formData.id_par ? true : false);
				this.config.disabled.padrao = (this.formData.id_par ? false : true);
				this.config.disabled.atualizar_tb_empresa = (this.formData.id_par ? false : true);
			},
		},
		data () {
			return {
				config:{
					click:{
						id_lab: this.getLaboratorio
					},
					list:{
						id_lab:[]
					},
					disabled:{
						valor_custo:true,
						valor_venda:true,
						padrao:true,
						parceiro_padrao:true,
						atualizar_tb_empresa:true
					},
					hidden:{
						id_lab:true,
						parceiro_padrao:false,
					},
					loading:{
						id_lab:false,
						save:false,
						table:false
					}
				},
				formData:{
					id:0,
					id_exa:null,
					valor_custo:0,
					valor_venda:0,
					padrao:0,
					atualizar_tb_empresa:0
				},
				pagination:{},
				response:{},
				tableHead:[
					{
						key: 'id',
						sortable: true,
						label: 'Cód',
					},
					{
						key: 'risco',
						sortable: true,
						label: 'Fator de Risco',
					},
					{
						key: 'id_lab',
						sortable: true,
						edit:'select-custom',
						info:'Esse é o laboratório padrão para esse Fator de Risco',
						label: 'Laboratório Padrão',
					},
					{
						key: 'valor_custo',
						sortable: true,
						edit:'money',
						label: 'Valor de Custo',
					},
					{
						key: 'valor_venda',
						sortable: true,
						edit:'money',
						label: 'Valor de Venda',
					},
				],
				tableData:[],
				formItems:[],
				loadingTable:false,
				loadingSave:false,
				showFormEdit:false,
			}
		},

		created(){
		},

		mounted: function() {
			this.formItems = FormItems;
			this.getRiscoLaboratorio();
		},

		methods: {

			onEditAll(data){
				
				this.config.loading.table = true;

				this.post('/laboratorio/fator-risco/'+this.laboratorio.id+'/editar-todos',{items:data}).then((result)=>{

					result = result[0];

					this.config.loading.table = false;
					
					if(result.status == 200){
						this.getRiscoLaboratorio();
					}
				});
			},

			

			getLaboratorio(_search){

				this.config.loading.id_lab = true;
				this.config.list.id_lab = [];

				this.get('laboratorio',{search:_search}).then((result)=>{

					result = result[0];

					this.config.loading.id_lab = false;

					if(result.status == 200){
						this.config.list.id_lab = result.data.data;
					}
				});
			},

			getRiscoLaboratorio: function(_search, _page, _pagination) {

				this.config.loading.table = true;
				this.config.list.id_lab = [];
				this.response = {};
			
				this.get('/laboratorio/fator-risco/'+this.laboratorio.id, {search: _search,page: _page,pagination: _pagination}).then(result => {
					
					result = result[0];
					this.response = result;
					this.config.loading.table = false;

					var data = [], tableData = [], pagination = {};

					if(result.status == 200){

						data = result.data.data;

						for (let i = 0; i < data.length; i++) {

							if(data[i].laboratorio && !this.arrFindByField(this.config.list.id_lab,'id',data[i].id_lab)){
								this.config.list.id_lab.push({
									id: data[i].id_lab,
									nome: data[i].laboratorio.nome
								});
							}

							var item = {
								'id': data[i].id,
								'risco': data[i].nome,
								'id_lab': (data[i].laboratorio ? data[i].laboratorio.nome : '---'),
								'valor_custo': data[i].valor_custo,
								'valor_venda': data[i].valor_venda,
								_data:data[i],
		             			options:{
									disable_delete:!this.validarPermissao(303),
									disable_edit:!this.validarPermissao(303),
									style:'color:'+(data[i].laboratorio && data[i].laboratorio.id == this.laboratorio.id ? 'green' : 'red')
								},
		             			buttons:[]
		             		};

		             		tableData.push(item);
						}

						pagination = result.data;
					}

					this.tableData = tableData;
					this.pagination = pagination;
				});
			},

			salvar(){

				this.config.loading.save = true;
				this.response = {};

				this.post('/parceiro/exames/'+this.parceiro.id+'/editar',this.formData).then((result)=>{

					result = result[0];
					this.response = result;

					this.config.loading.save = false;

					if(result.status == 200){

						// this.$message({
						// 	message: 'Dados a com sucesso!',
						// 	type: 'success'
						// });
						this.edMsg('Dados a com sucesso!')
						this.showFormEdit = !this.showFormEdit;
						this.getRiscoLaboratorio();
					}

				});
			},

		}
	}
</script>


// WEBPACK FOOTER //
// index.vue?f99d82e6